<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>任务管理</a-breadcrumb-item>
    <a-breadcrumb-item>待入库</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <!-- 剧名 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">剧名：</a-col>
          <a-col :span="18">
            <a-input
              class="tool-item"
              v-model:value="dramaNameModel"
              placeholder="请输入"
            />
          </a-col>
        </a-row>
      </a-col>
      <!-- 渠道 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">渠道：</a-col>
          <a-col :span="18">
            <a-select
              class="tool-item"
              v-model:value="channelModel"
              placeholder="请选择"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in channels" :key="`${item.channel_id} - ${item.name}`" :value="item.channel_id">{{ item.name }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 分成方式 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title">分成方式：</a-col>
          <a-col :span="18">
            <a-select
              class="tool-item"
              v-model:value="divisionModel"
              placeholder="请选择"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option v-for="item in DivisionTypes" :key="item.value" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
      </a-col>
      <!-- 操作 -->
      <a-col :span="6">
        <a-row>
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
            <a-button style="margin-left: 16px" @click="touchGrab" :disabled="isGrabLoading">抓取融合任务</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 多选组件 -->
  <TableCheckbox
    sourceKey="id"
    :dataSource="dataSource"
    :selectedRowKeys="selectedRowKeys"
    :selectedRows="selectedRows"
    :pagination="pagination"
    :isLoading="isLoading"
  >
    <!-- 按钮文案 -->
    <template #checkbox>
      <!-- 入库 -->
      <a-button style="margin-left: 10px;" @click="touchBatchInWarehouse(selectedRowKeys, selectedRows)">入库</a-button>
      <!-- 不入库 -->
      <a-button style="margin-left: 10px;" @click="touchBatchNoInWarehouse(selectedRowKeys)">不入库</a-button>
    </template>
    <!-- 列表 -->
    <a-table
      class="table-view"
      :data-source="dataSource"
      :columns="columns"
      :row-key="record => record.id"
      :pagination="pagination"
      :loading="isLoading"
      :scroll="{ x: scrollX, y: 'max-content' }"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      @change="handleTableChange"
    >
      <!-- 自定义行内容 -->
      <template #bodyCell="{ column, record }">
        <!-- 频道 -->
        <template v-if="column.key === 'playlet_gender'">
          {{ DramaChannelTypes
            .filter(channel => (record.playlet_gender || []).includes(channel.value))
            .map(channel => channel.text)
            .join('、') || '-'
          }}
        </template>
        <!-- 操作 -->
        <template v-if="column.key === 'operation'">
          <a class="operation-item" @click="touchBatchInWarehouse([record.id], [record])">入库</a>
          <a class="operation-item" @click="touchBatchNoInWarehouse([record.id])">不入库</a>
        </template>
      </template>
    </a-table>
  </TableCheckbox>
  <!-- 任务入库 -->
  <InWarehouse ref="RefInWarehouse" @success="getList" />
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { DramaChannelTypes, DivisionTypes } from '@/utils/constantList'
import { message, Modal } from 'ant-design-vue'
import { storageList, storageCheck, channelSelectList, storageRefreshData } from '@/api/request'
import moment from 'moment'
import TableCheckbox from '@/components/TableCheckbox'
import InWarehouse from './components-pending-storage/InWarehouse.vue'

// 入库
let RefInWarehouse = ref(null)
// 剧名
let dramaName = ref(undefined)
let dramaNameModel = ref(undefined)
// 渠道
let channel = ref(undefined)
let channelModel = ref(undefined)
let channels = ref([])
// 分成方式
let division = ref(undefined)
let divisionModel = ref(undefined)
// 抓取时间
let grabTime = ref(0)
// 加载
let isLoading = ref(false)
let isGrabLoading = ref(false)
// 选中
let selectedRowKeys = ref([])
let selectedRows = ref([])
// 数据源
let dataSource = ref([])
// 滚动范围
let scrollX = ref(0)
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '抓取时间',
    dataIndex: 'date',
    key: 'date',
    fixed: 'left',
    width: 100
  },
  {
    title: '任务名称',
    dataIndex: 'demand_name',
    key: 'demand_name',
    width: 100
  },
  {
    title: '短剧名称',
    dataIndex: 'name',
    key: 'name',
    width: 100
  },
  {
    title: '剧场名称',
    dataIndex: 'app_name',
    key: 'app_name',
    width: 100
  },
  {
    title: '渠道',
    dataIndex: 'channel_name',
    key: 'channel_name',
    width: 100
  },
  {
    title: '频道',
    dataIndex: 'playlet_gender',
    key: 'playlet_gender',
    width: 100
  },
  {
    title: '集数',
    dataIndex: 'total_ep',
    key: 'total_ep',
    width: 100
  },
  {
    title: '投稿开始时间',
    dataIndex: 'expiration_time',
    key: 'expiration_time',
    width: 100
  },
  {
    title: '服务商星图分成比例',
    dataIndex: 'commission_rate_text',
    key: 'commission_rate_text',
    width: 100
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    fixed: 'right',
    width: 100
  }
])

onBeforeMount (() => {
  // 抓取时间
  grabTime.value = Number(localStorage.getItem('grab_time') || 0)
  // 初始化选择项列表
  getSelectList()
  // 初始化获取
  touchSearch()
  // 获取滚动宽度
  getScrollX()
})

// 初始化选择项列表
function getSelectList () {
  channelSelectList().then(res => {
    const { code, data } = res
    if (code === 0) {
      channels.value = data
    }
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getList()
}

// 多选处理
function onSelectChange (rowKeys, rows) {
  selectedRowKeys.value = rowKeys
  selectedRows.value = rows
}

// 查询
function touchSearch () {
  // 调整参数
  dramaName.value = dramaNameModel.value
  channel.value = channelModel.value
  division.value = divisionModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  dramaName.value = undefined
  dramaNameModel.value = undefined
  channel.value = undefined
  channelModel.value = undefined
  division.value = undefined
  divisionModel.value = undefined
  // 初始化获取
  touchSearch()
}

// 滚动X
function getScrollX () {
  var x = 0
  columns.value.forEach(item => {
    x += item.width
  })
}

// 批量操作入库
function touchBatchInWarehouse (ids, objs) {
  if (ids.length) {
    inWarehouse(ids, objs);
  } else {
    message.error('请选择任务')
  }
}

// 批量操作不入库
function touchBatchNoInWarehouse (ids) {
  if (ids.length) {
    Modal.confirm({
      title: '确定不入库吗?',
      onOk() {
        noInWarehouse(ids);
      },
    });
  } else {
    message.error('请选择任务')
  }
}

// 入库
function inWarehouse (ids, objs) {
  storageCheck({ids: ids}).then(res => {
    const { code } = res
    if (code === 0) {
      RefInWarehouse.value.showDrawer(ids, objs[0])
    } else {
      message.error(res.message)
    }
  })
}

// 不入库
function noInWarehouse (ids) {
  storageCheck({ids: ids, is_store: 2}).then(res => {
    const { code, msg } = res
    if (code === 0) {
      message.success('操作成功')
      // 更新列表
      getList()
    }
  })
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    name: dramaName.value,
    channel_id: channel.value,
    pay_type: division.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  storageList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
      // 清空选中
      selectedRowKeys.value = []
      selectedRows.value = []
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 抓取任务
function touchGrab () {
  const currentTimestamp = Date.now();
  if (grabTime.value < currentTimestamp) {
    isGrabLoading.value = true
    storageRefreshData().then(res => {
      isGrabLoading.value = false
      const { code, data } = res
      if (code === 0) {
        grabTime.value = data.last_time
        localStorage.setItem('grab_time', grabTime.value)
        const formattedDate = moment(grabTime.value).format('YYYY-MM-DD HH:mm:ss')
        message.success(`抓取中，下次操作请在 ${formattedDate} 后`)
      }
    }).catch(() => {
      isGrabLoading.value = false
    })
  } else {
    isGrabLoading.value = false
    const formattedDate = moment(grabTime.value).format('YYYY-MM-DD HH:mm:ss')
    message.error(`抓取中，下次操作请在 ${formattedDate} 后`)
  }
}
</script>

<style scoped>
.cover-img {
  display: inline-block;
  width: 40px;
  height: 40px;
}
.cover-title {
  margin-left: 10px;
}
</style>